import { createClient } from '@supabase/supabase-js'
import { validateCaiQaSupabaseIdentity } from './currentAssetIntelligence/caiQaSupabaseIdentity'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY
const qaIdentity = validateCaiQaSupabaseIdentity({
  qaMode: process.env.REACT_APP_TOREN_CAI_QA_MODE,
  expectedProjectRef: process.env.REACT_APP_TOREN_CAI_QA_SUPABASE_PROJECT_REF,
  supabaseUrl,
})

if (!qaIdentity.ok) {
  throw new Error('CAI QA Supabase project identity is not the approved QA project')
}

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Missing Supabase frontend environment variables: REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY'
  )
}

export const supabase = createClient(supabaseUrl, supabaseKey)
